module.exports = __webpack_public_path__ + "img/cloud-4.4fe0e9ff.svg";